import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import moment from 'moment';

export const regExps: { [key: string]: RegExp } = {
  cpf: /^\d{3}.\d{3}.\d{3}-\d{2}$/,
  cnpj: /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}\-?\d{2}$/,
  name: /\s*?\w.*\s.*\w.*\s?/,
  birthDate: /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
  birthDateComplex: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
  email: /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/,
  cellphone: /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][1-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/,
  phone: /^(?:\(?([1-9][1-9])\)?\s?)?(?:((?:[2-5])\d{3})\-?(\d{4}))$/,
  zipcode: /^(\d{5}-\d{3}|\d{8})$/,
  pisPasep: /\d{3}\.?\d{5}\.?\d{2}\-?\d{1}/,
  cardName: /^([a-zA-Z\s]+)$/
};

export const cards = {
  'visa': /^4[0-9]{12}(?:[0-9]{3})/,
  'mastercard': /^5[1-5][0-9]{14}/,
  'diners-club': /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
  'amerian-express': /^3[47][0-9]{13}/,
  'discover': /^6(?:011|5[0-9]{2})[0-9]{12}/,
  'hipercard': /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
  'elo': /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
  'jcb': /^(?:2131|1800|35\d{3})\d{11}/,
  'aura': /^(5078\d{2})(\d{2})(\d{11})$/,
};
/*
  Validate PISPASEP
*/
export function ValidatePisPasep(control: AbstractControl) {
  if (
    !regExps.pisPasep.test(control.value) ||
    !isValidPisPasep(control.value.replace(/[^0-9]/g, ""))
  ) {
    return { pisPasepError: "Informe um PIS/PASEP válido" };
  }
  return null;
}

export function validatePlan(control: AbstractControl) {
  if (
    sessionStorage.getItem("planIdentifier") === null ||
    sessionStorage.getItem("planIdentifier") === ""
  ) {
    return { myPlanSelectionError: "Selecione um Plano" };
  }

  return null;
}

export function ValidateCNPJ(control: AbstractControl): { [key: string]: any } {
  if (!control.value) return null;
  const digits = control.value.replace(/[^0-9]/g, '');
  if (digits.length !== 14 || !isValidCNPJ(digits)) {
    return { cnpjError: "Informe um CNPJ válido." };
  }
  return null;
}

export function ValidateText(control: AbstractControl) {
  if(control && control.value && control.value.length) {
    if(control.value.replace(/\s/g, '').length < 0){
      //return { messageError: "Mínimo de 20 caracteres"};
    }
  }
  return null;
}
export function ValidateCPFCNPJ(control: AbstractControl) {
  if (control && control.value && control.value.length) {
    if (control.value.length === 14) {
      if (!regExps.cpf.test(control.value) || !isValidCPF(control.value.replace(/[^0-9]/g, ''))) {
        return { cpfCnpjError: "Informe um CPF válido" };

      }
    } else if (control.value.length === 18) {
      if (!regExps.cnpj.test(control.value) || !isValidCNPJ(control.value.replace(/[^0-9]/g, ''))) {
        return { cpfCnpjError: "Informe um CNPJ válido" };
      }
    }
  }
  return null;
}

export function isValidCNPJ(cnpj): boolean {
  let numeros, digitos, soma, i, resultado, pos, tamanho, digitosIguais;
  digitosIguais = 1;
  if (cnpj.length !== 14) {
    return false;
  }
  for (i = 0; i < cnpj.length - 1; i++) {
    if (cnpj.charAt(i) !== cnpj.charAt(i + 1)) {
      digitosIguais = 0;
      break;
    }
  }
  if (!digitosIguais) {
    tamanho = cnpj.length - 2;
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado.toString() !== digitos.charAt(0)) {
      return false;
    }
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado.toString() !== digitos.charAt(1)) {
      return false;
    }
    return true;
  } else {
    return false;
  }
}

export function isValidPisPasep(pisPasep): boolean {
  const multiplicadorBase = "3298765432";
  let total = 0;
  let resto = 0;
  let multiplicando = 0;
  let multiplicador = 0;
  let digito = 99;

  // Retira a mascara
  const numeroPIS = pisPasep.replace(/[^\d]+/g, "");

  if (
    numeroPIS.length !== 11 ||
    numeroPIS === "00000000000" ||
    numeroPIS === "11111111111" ||
    numeroPIS === "22222222222" ||
    numeroPIS === "33333333333" ||
    numeroPIS === "44444444444" ||
    numeroPIS === "55555555555" ||
    numeroPIS === "66666666666" ||
    numeroPIS === "77777777777" ||
    numeroPIS === "88888888888" ||
    numeroPIS === "99999999999"
  ) {
    return false;
  } else {
    for (let i = 0; i < 10; i++) {
      multiplicando = parseInt(numeroPIS.substring(i, i + 1));
      multiplicador = parseInt(multiplicadorBase.substring(i, i + 1));
      total += multiplicando * multiplicador;
    }

    resto = 11 - (total % 11);
    resto = resto === 10 || resto === 11 ? 0 : resto;

    digito = parseInt("" + numeroPIS.charAt(10));
    return resto === digito;
  }
}

/*
  BirthDate Validation
*/

/*
  BirthDate Validation
*/

export function validateBirthDate(minAge: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const YEAR_LIMIT = 1900;
    if (!control.value) {
      return null;
    }
    let value: string = control.value;
    if (/^\d{8}$/.test(value)) {
      value = `${value.substring(0, 2)}/${value.substring(2, 4)}/${value.substring(4, 8)}`;
    }
    if (!control.disabled && regExps.birthDate.test(value)) {

      const inputDate = new Date(`${value.substring(3, 5)}/${value.substring(0, 2)}/${value.substring(6, 10)}`);

      if (!validateNoFutureDate(inputDate)) {
        return { birthDateError: 'Informe uma data de nascimento inferior ou igual à data atual' };
      } else if (!validateMinAge(inputDate, minAge)) {
        return { birthDateError: 'É obrigatório ser maior de ' + minAge + ' anos' };
      } else if (!validateMaxAge(inputDate, YEAR_LIMIT)) {
        return { birthDateError: 'Informe uma data de nascimento posterior à 1900' };
      }
    } else {
      return { birthDateError: 'Informe uma data de nascimento válida' };
    }

    return null;
  };
}

export function validateNoFutureDate(date): boolean {
  return date <= new Date();
}

export function validateMaxAge(birthDate, yearLimit) {
  return birthDate.getFullYear() >= yearLimit;
}

export function validateMinAge(birthDate, minAge): boolean {
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age >= minAge;
}

/*
  CPF Validation
*/
export function ValidateCPF(control: AbstractControl) {
  if (!control.value) return null;
  const digits = control.value.replace(/[^0-9]/g, '');
  if (digits.length !== 11 || !isValidCPF(digits)) {
    return { cpfError: "Informe um CPF válido" };
  }
  return null;
}

export function PasswordMatchValidator(control: AbstractControl) {
  const password: string = control.get("password").value; // get password from our password form control
  const confirmPassword: string = control.get("confirmPassword").value; // get password from our confirmPassword form control
  // compare is the password math
  if (password !== confirmPassword) {
    // if they don't match, set an error in our confirmPassword form control
    control
      .get("confirmPassword")
      .setErrors({ NoPassswordMatch: "Senhas não coincidem" });
  }
}

export function isValidCPF(cpf): boolean {
  if (cpf.length !== 11) {
    return false;
  }
  const rcpf1 = cpf.substring(0, 9);
  const rcpf2 = cpf.substring(9);
  let d1 = 0;
  for (let i = 0; i < 9; i++) {
    d1 += parseInt(rcpf1.substring(i, i + 1)) * (10 - i);
  }
  d1 = 11 - (d1 % 11);
  if (d1 > 9) {
    d1 = 0;
  }
  if (parseInt(rcpf2.substring(0, 1)) !== d1) {
    return false;
  }
  d1 *= 2;
  for (let j = 0; j < 9; j++) {
    d1 += parseInt(rcpf1.substring(j, j + 1) + "") * (11 - j);
  }
  d1 = 11 - (d1 % 11);
  if (d1 > 9) {
    d1 = 0;
  }
  if (parseInt(rcpf2.substring(1, 2) + "") !== d1) {
    return false;
  }
  if (parseInt(cpf) - parseInt(Array(12).join(cpf[0])) === 0) {
    return false;
  }
  return true;
}

/*
  Validate Zipcode
*/
export function ValidadeZipcode(control: AbstractControl) {
  if (!regExps.zipcode.test(control.value)) {
    return { invalidZipcode: "Informe CEP válido" };
  }
  return null;
}

export function ValidadeCardName(control: AbstractControl) {
  if (!regExps.cardName.test(control.value)) {
    return { cardNameError: "Informe um nome do cartão válido" };
  }

  return null;
}


export function ValidateCardNumber(control: AbstractControl) {
  if (control.value && getCardBrand(control.value) === false) {
    return { cardNumberError: "Informe um número de cartão válido" };
  }

  return null;
}



export function getCardBrand(cardnumber): any {
  cardnumber = cardnumber.replace(/[^0-9]+/g, "");

  for (let flag in cards) {
    if (cards[flag].test(cardnumber)) {
      return flag;
    }
  }

  return false;
}
/*
  Validate CellPhone
*/
export function ValidateCellphone(control: AbstractControl) {
  if (!regExps.cellphone.test(control.value)) {
    return { cellphoneError: "Informe um telefone celular válido" };
  }
  return null;
}

/*
  Validate Full Name
*/
export function ValidateName(control: AbstractControl) {
  if (!control.value || !regExps.name.test(control.value)) {
    return { nameError: "Informe nome completo válido" };
  }
  return null;
}

/**
 * Valida se a data de expiração do cartão é uma data válida (após a mm/aa de hoje)
 * @param control - Valor do campo expirationDate
 */
export function ValidateExpirationDate(control: AbstractControl){
  if (control.value && !isValidExpirationDate(control.value)) {
    return {expirationDateError: 'Informe uma data de expiração válida'};
  }

  return null;
}

export function isValidExpirationDate(expirationDate: string){
  return moment(moment().format('MM/YY'), 'MM/YY').isSameOrBefore(moment(expirationDate, "MM/YY"));
}

/*
  Validate Phone
*/
export function ValidatePhone(control: AbstractControl) {
  if (control.value && !regExps.phone.test(control.value)) {
    return { phoneError: "Informe um telefone fixo válido" };
  }
  return null;
}

/*
  validate Email
*/
export function ValidateEmail(control: AbstractControl) {
  if (!regExps.email.test(control.value)) {
    return { emailError: "Informe um e-mail válido" };
  }
  return null;
}

export function ValidateSameEmail(mainEmail: string, emailConfirm: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const email = formGroup.get(mainEmail)?.value;
    const confirm = formGroup.get(emailConfirm)?.value;

    if (email && confirm && email !== confirm) {
      formGroup.get(emailConfirm)?.setErrors({ emailConfirmError: "Informe um e-mail igual ao principal" });
      return { emailConfirmError: "Informe um e-mail igual ao principal" };
    }

    return null;
  };
}